<template>
  <footer class="app-footer">
    <div class="footer-decoration">
      <img src="/public/images/footer_pic.webp" alt="Декоративное изображение" class="footer-image">
    </div>
    <div class="footer-container">
      <div class="footer-brand">
        <div class="site-name">Лавка поднебесной</div>
        <div class="copyright">© 2025 All Rights Reserved</div>
      </div>

      <nav class="footer-links">
        <RouterLink to="/faq" class="footer-link">FAQ</RouterLink>
        <RouterLink to="/privacy-policy" class="footer-link">Политика конфиденциальности</RouterLink>
        <RouterLink to="/public-offer" class="footer-link">Публичная оферта</RouterLink>
      </nav>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router';
</script>

<style scoped>
.app-footer {
  background-color: var(--black);
  color: #ecf0f1;
  padding: 80px;
  margin-top: 120px;
  border-radius: 32px 32px 0 0;
  position: relative;
}

.footer-decoration {
  position: absolute;
  top: 0;
  left: 100px;
  width: 100%;
  max-width: 200px;
  z-index: -1;

  @media (max-width: 768px) {
    top: 40px;
  }

  @media (max-width: 480px) {
    top: 60px;
    left: 40px;
  }
}

.footer-image {
  position: absolute;
  top: -140px;
  width: 100%;
  height: auto;
}

.footer-container {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: stretch;
  max-width: 1200px;
  margin: 0 auto;
  gap: 2rem;
  position: relative;
  z-index: 2;
}

.footer-brand {
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100%;
}

.site-name {
  font-size: 1.5rem;
  align-self: start;
  font-family: var(--font-heading), serif;
}

.copyright {
  font-size: 0.9rem;
  opacity: 0.8;
  align-self: end;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-wrap: wrap;
}

.footer-link {
  color: #ecf0f1;
  text-decoration: none;
  font-size: 0.95rem;
  transition: opacity 0.3s ease;
  white-space: nowrap;
}

.footer-link:hover {
  opacity: 0.8;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .app-footer {
    margin-top: 80px;
    padding: 48px 48px 80px;
  }

  .footer-decoration {
    max-width: 150px;
  }

  .footer-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .footer-brand {
    height: auto;
    gap: 1rem;
  }

  .footer-links {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.8rem;
  }
}

@media (max-width: 480px) {
  .app-footer {
    border-radius: 0;
    padding-top: 60px;
  }

  .footer-decoration {
    max-width: 120px;
  }
}
</style>
